<script setup lang="ts">
import { ref, onMounted, onUnmounted, type Component } from 'vue';

import {
  subscribeToCustomEvent,
  unsubscribeFromCustomEvent,
  emitCustomEvent
} from '@satellite/composables/useEventBasedDialog';

const props = defineProps<{
  eventName: string;
  component: Component;
}>();

const shouldMount = ref(false);
const pendingProps = ref<CustomEvent['detail'] | null>(null);

const handleTriggerEvent = (event: CustomEvent) => {
  pendingProps.value = event.detail;

  if (!shouldMount.value) {
    shouldMount.value = true;
    unsubscribeFromCustomEvent(props.eventName, handleTriggerEvent);
  }
};

const handleReady = () => {
  emitCustomEvent(props.eventName, pendingProps.value);
  pendingProps.value = null;
};

onMounted(() => {
  subscribeToCustomEvent(props.eventName, handleTriggerEvent);
});

onUnmounted(() => {
  unsubscribeFromCustomEvent(props.eventName, handleTriggerEvent);
});
</script>

<template>
  <component :is="component" v-if="shouldMount" @ready="handleReady" />
</template>
